var $54b47fc030b7b21e$exports = {};
// Newsletter tabs
document.querySelectorAll(".newsletter-tab").forEach((tab)=>{
    tab.addEventListener("click", ()=>{
        document.querySelectorAll(".newsletter-tab").forEach((t)=>t.classList.remove("active"));
        document.querySelectorAll(".newsletter-content").forEach((c)=>c.classList.remove("active"));
        tab.classList.add("active");
        document.getElementById(tab.id === "tab-join-btn" ? "tab-join-content" : "tab-don-content").classList.add("active");
    });
    tab.addEventListener("keydown", (e)=>{
        if (e.key === "Enter" || e.key === " ") tab.click();
    });
});
// Slider
const $54b47fc030b7b21e$var$slider = document.querySelector(".evenement-slider");
const $54b47fc030b7b21e$var$cards = Array.from(document.querySelectorAll(".evenement-card"));
const $54b47fc030b7b21e$var$sliderContainer = document.querySelector(".evenement-slider-container");
let $54b47fc030b7b21e$var$current = 0;
if ($54b47fc030b7b21e$var$slider && $54b47fc030b7b21e$var$cards.length > 0) {
    // ← ajoute cette condition
    function getStep() {
        if ($54b47fc030b7b21e$var$cards.length < 2) return ($54b47fc030b7b21e$var$cards[0]?.offsetWidth ?? 420) + 40;
        return $54b47fc030b7b21e$var$cards[1].offsetLeft - $54b47fc030b7b21e$var$cards[0].offsetLeft;
    }
    function updateSlider() {
        const step = getStep();
        const anchor = $54b47fc030b7b21e$var$cards[0].offsetLeft;
        $54b47fc030b7b21e$var$cards.forEach((card, i)=>{
            card.classList.toggle("active", i === $54b47fc030b7b21e$var$current);
            card.classList.toggle("next", i === ($54b47fc030b7b21e$var$current + 1) % $54b47fc030b7b21e$var$cards.length);
        });
        $54b47fc030b7b21e$var$slider.style.transform = `translateX(${-($54b47fc030b7b21e$var$current * step + anchor)}px)`;
    }
    const prevBtn = document.querySelector(".evenement-arrows .button-dark:first-child");
    const nextBtn = document.querySelector(".evenement-arrows .button-dark:last-child");
    if (prevBtn && nextBtn) {
        prevBtn.onclick = (e)=>{
            e.preventDefault();
            $54b47fc030b7b21e$var$current = ($54b47fc030b7b21e$var$current - 1 + $54b47fc030b7b21e$var$cards.length) % $54b47fc030b7b21e$var$cards.length;
            updateSlider();
        };
        nextBtn.onclick = (e)=>{
            e.preventDefault();
            $54b47fc030b7b21e$var$current = ($54b47fc030b7b21e$var$current + 1) % $54b47fc030b7b21e$var$cards.length;
            updateSlider();
        };
    }
    window.addEventListener("resize", ()=>updateSlider());
    updateSlider();
} // ← ferme ici
// Burger menu
const $54b47fc030b7b21e$var$burger = document.querySelector(".burger");
const $54b47fc030b7b21e$var$navLinks = document.getElementById("nav-links");
if ($54b47fc030b7b21e$var$burger && $54b47fc030b7b21e$var$navLinks) $54b47fc030b7b21e$var$burger.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$navLinks.classList.toggle("active");
    $54b47fc030b7b21e$var$burger.classList.toggle("active");
});
// Financement popup
const $54b47fc030b7b21e$var$popup = document.querySelector(".financement-popup");
const $54b47fc030b7b21e$var$content = document.querySelector(".financement-popup-content");
const $54b47fc030b7b21e$var$closeBtn = document.querySelector(".financement-popup-top a");
const $54b47fc030b7b21e$var$flag = document.querySelector(".flag");
function $54b47fc030b7b21e$var$closePopup() {
    $54b47fc030b7b21e$var$popup.classList.add("closing");
    $54b47fc030b7b21e$var$popup.addEventListener("animationend", ()=>{
        $54b47fc030b7b21e$var$popup.classList.add("hidden");
        $54b47fc030b7b21e$var$popup.classList.remove("closing");
    }, {
        once: true
    });
}
$54b47fc030b7b21e$var$flag.addEventListener("click", (e)=>{
    e.preventDefault();
    $54b47fc030b7b21e$var$popup.classList.remove("hidden");
});
$54b47fc030b7b21e$var$closeBtn.addEventListener("click", (e)=>{
    e.preventDefault();
    $54b47fc030b7b21e$var$closePopup();
});
$54b47fc030b7b21e$var$popup.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$closePopup();
});
$54b47fc030b7b21e$var$content.addEventListener("click", (e)=>{
    e.stopPropagation();
});


//# sourceMappingURL=index.e3dbcd71.js.map
